module.exports = __webpack_public_path__ + "img/vertical_7_6_5.b85be56c.png";